export enum CustomiseSections {
  VARIANT = 'variant',
  INTERIOR = 'interior',
  EXTERIOR = 'colour',
  ACCESSORIES = 'accessories',
  ACCESSORY = 'accessory',
  PACKS = 'options',
  JAGUARGEAR = 'jaguar_gear',
  SERVICE_PLAN = 'service',
  SUMMARY = 'summary',
  SELECTIONS = 'selections',
  DISCLAIMER = 'disclaimer',
  STOCK = 'stock',
}
